import React, { useState } from 'react';

import { FormInput } from '@/components/shared/Inputs';
import { Blurb } from '@/components/shared/Inputs/Blurb';
import { Label } from '@/components/shared/Inputs/Label';
import { SingleActionLayout } from '@/components/shared/SingleActionLayout/SingleActionLayout';
import { TeamSong } from '@/graphql';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { AddCustomSongDisplayProps } from '../AddCustomSong';
import styles from './AppleMusicUrl.module.scss';

type FormSchema = {
	appleMusicId?: string;
};

type Props = {
	teamSong: Partial<Pick<TeamSong, 'appleMusicId'>>;
	onSubmit: (values: { appleMusicId: TeamSong['appleMusicId'] }) => void;
};

const validationSchema: Yup.SchemaOf<FormSchema> = Yup.object().shape({
	appleMusicId: Yup.string()
		.optional()
		.matches(/^(?=https:\/\/).+(?=apple).+/, 'The URL must be valid')
		.max(500, 'Can not be more than 500 characters'),
	// appleMusicId: Yup.string().required('Please enter a valid url'),
});

export const AppleMusicUrl: React.FC<Props> = ({ teamSong, onSubmit }) => {
	const { appleMusicId } = teamSong;
	const [touched, setTouched] = useState(false);
	const initialValues: FormSchema = {
		appleMusicId: appleMusicId || '',
	};
	return (
		<Formik
			key="asaphSignUn"
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={async (values) => {
				onSubmit({
					appleMusicId: values.appleMusicId || null,
				});
			}}
		>
			{({ handleSubmit, handleChange, values, errors, isValid }) => (
				<SingleActionLayout
					actionLabel="Save Apple Music URL"
					actionDisabled={!isValid || !touched}
					onActionClick={handleSubmit}
				>
					<form
						onSubmit={handleSubmit}
						id="asaphSignIn"
						className={styles['root']}
					>
						<Label>Song Apple Music URL</Label>
						<FormInput
							placeholder="Enter url"
							name="appleMusicId"
							id="appleMusicId"
							autoComplete="off"
							value={values.appleMusicId}
							onChange={(e) => {
								setTouched(true);
								handleChange(e);
							}}
							error={!!errors.appleMusicId}
						/>
						{errors.appleMusicId && (
							<Blurb isError>{errors.appleMusicId}</Blurb>
						)}
						<Blurb>
							To copy song URL, view your song on Apple Music,
							then go to ••• &gt; Share Song &gt; Copy link.
						</Blurb>
					</form>
				</SingleActionLayout>
			)}
		</Formik>
	);
};
